import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { useTranslation } from '@acitra/i18n';
import { useAuthStore } from './stores/auth-store';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';

function Dashboard() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-gray-900">Admin Dashboard</h1>
      <p className="mt-2 text-gray-600">Platform administration overview</p>
    </div>
  );
}

function Header() {
  const { t } = useTranslation();
  const { user, logout } = useAuthStore();

  return (
    <header className="bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <span className="text-xl font-bold text-white">
              {t('common.appName')} <span className="text-gray-400">Admin</span>
            </span>
          </div>
          <nav className="flex items-center space-x-8">
            <Link to="/" className="text-gray-300 hover:text-white">
              Dashboard
            </Link>
            <Link to="/tenants" className="text-gray-300 hover:text-white">
              Tenants
            </Link>
            <Link to="/monitoring" className="text-gray-300 hover:text-white">
              Monitoring
            </Link>
            <Link to="/support" className="text-gray-300 hover:text-white">
              Support
            </Link>
            <div className="flex items-center space-x-4 border-l border-gray-700 pl-8">
              <span className="text-gray-400 text-sm">{user?.email}</span>
              <button onClick={() => logout()} className="text-gray-300 hover:text-white text-sm">
                Sign out
              </button>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}

function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>{children}</main>
    </div>
  );
}

function App() {
  const { initialize } = useAuthStore();

  // Initialize auth state on app load
  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Dashboard />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/tenants"
          element={
            <ProtectedRoute>
              <AppLayout>
                <div className="p-8">Tenants Management</div>
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/monitoring"
          element={
            <ProtectedRoute>
              <AppLayout>
                <div className="p-8">System Monitoring</div>
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/support"
          element={
            <ProtectedRoute>
              <AppLayout>
                <div className="p-8">Support Tools</div>
              </AppLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
